// §J (Addendum June 2026): GBS Gestational Age Window Correction
// Corrects collection window from 36–37w (252–265d) to 35–37w (245–265d).
// All three enforcement points (LabsInput, validation.ts, admission gate) read from these constants.
// The practice admin may override gbsGaTriggerDays and gbsWindowEndDays via settings/gbsConfig in Firestore.

export interface GbsConfig {
  /** GA (days) at which GBS collection becomes active — default 245 (35w0d) */
  gbsGaTriggerDays: number
  /** Last GA day (inclusive) within the collection window — default 265 (37w+6d) */
  gbsWindowEndDays: number
  /** GA (days) at which the "window passed" system flag fires — default 266 (38w0d) */
  gbsPassedDays: number
}

export const DEFAULT_GBS_CONFIG: GbsConfig = {
  gbsGaTriggerDays: 245,
  gbsWindowEndDays: 265,
  gbsPassedDays: 266,
}

// Named constants consumed by validation.ts (which cannot use React hooks)
export const GBS_GA_TRIGGER_DAYS = 245
export const GBS_WINDOW_END_DAYS = 265
